export const LEGAL_CONFIG = {
  appName: 'Gestion PIAL',
  appUrl: 'https://gestion-pial.fr',
  editorName: 'CRUZ Maximilien',
  editorStatus: 'Auto-entrepreneur',
  editorEmail: 'maximilien.cruz@gmail.com',
  editorAddress: '', // à compléter
  publicationDirector: 'CRUZ Maximilien',
  hostName: 'OVH',
  hostAddress: '2 rue Kellermann, 59100 Roubaix, France',
  hostWebsite: 'https://www.ovhcloud.com',
  dataLocation: 'France',
  cnilUrl: 'https://www.cnil.fr/fr/plaintes',
  lastUpdated: {
    mentionsLegales: '03/04/2026',
    policy: '03/04/2026',
    cgu: '03/04/2026',
    cgv: '03/04/2026',
    cookies: '03/04/2026',
  },
};
